import { render, staticRenderFns } from "./FormulateStatusBadge.vue?vue&type=template&id=059ecdac&"
import script from "./FormulateStatusBadge.vue?vue&type=script&lang=js&"
export * from "./FormulateStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059ecdac')) {
      api.createRecord('059ecdac', component.options)
    } else {
      api.reload('059ecdac', component.options)
    }
    module.hot.accept("./FormulateStatusBadge.vue?vue&type=template&id=059ecdac&", function () {
      api.rerender('059ecdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/status-badge/FormulateStatusBadge.vue"
export default component.exports